import React, { useState, useEffect, useCallback } from "react";

const Dot = () => {
    const [position, setPosition] = useState({
        x: 0,
        y: 0
    });

    const handleMouseMove = useCallback((e) => {
        setPosition({
            x: e.clientX,
            y: e.clientY
        });
    }, []);

    useEffect(() => {
        window.addEventListener("mousemove", handleMouseMove);
        
        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
        };
    }, [handleMouseMove]);

    return (
        <div 
            className="c-dot" 
            style={{ 
                left: `${position.x}px`, 
                top: `${position.y}px` 
            }}
        />
    );
};

export default Dot;